import type { QuoteTerms, OptionsDocument } from 'paintscout'
export function updateToLatestTerms({ terms, options }: { terms: QuoteTerms; options: OptionsDocument }) {
  if (!terms?.name || terms?.custom || !options.options.terms?.values?.[terms?.name]) {
    return terms
  }

  return options.options.terms.values[terms.name]
}
